import { render } from "./FGCAdminView.vue?vue&type=template&id=629a68b2&scoped=true&ts=true"
import script from "./FGCAdminView.vue?vue&type=script&lang=ts"
export * from "./FGCAdminView.vue?vue&type=script&lang=ts"

import "./FGCAdminView.vue?vue&type=style&index=0&id=629a68b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629a68b2"]])

export default __exports__